<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="ma-4" v-if="dataLoaded">
          <v-card-title class="justify-center text-h4">Resultate</v-card-title>

          <v-card-text class="d-flex">
            <v-row>
              <v-col cols="12" sm="6" class="justify-center align-center">
                <div class="d-flex justify-center mb-0">
                  <v-progress-circular class="d-flex" :rotate="-90" :size="100" :width="18" :value="100" :color="theme.elements.btnColor">
                    <div class="text-h6">{{ moduleStats.questionsCount }}</div>
                  </v-progress-circular>
                </div>
                <div class="d-flex text-subtitle1 justify-center mb-6 description">
                  <div class="d-flex text-center">
                    {{ $t('el.numberOfQuestions', { questionsCount: moduleStats.questionsCount }) }}
                  </div>
                </div>
              </v-col>

              <v-col cols="12" sm="6" class="justify-center">
                <div class="d-flex justify-center mb-0">
                  <v-progress-circular
                    class="d-flex"
                    :rotate="-90"
                    :size="100"
                    :width="18"
                    :value="(100 * moduleStats.correctOnes) / moduleStats.questionsCount"
                    color="success"
                  >
                    <div class="text-subtitle1">{{ percentageCorrect }}%</div>
                  </v-progress-circular>
                </div>
                <div class="d-flex text-subtitle1 justify-center mb-6 description">
                  <div class="d-flex text-center">
                    {{ $t('el.correctSolvedQuestions', { correctSolvedQuestionsCount: `${moduleStats.correctOnes} (=${this.percentageCorrect}%)` }) }}
                  </div>
                </div>
              </v-col>

              <v-col cols="12" sm="12" class="justify-center">
                <v-row justify="space-around" class="d-flex text-subtitle1 justify-space-around mb-0 description">
                  <v-col cols="12" class="text-center">
                    <v-chip class="mr-2" v-if="!xs">
                      {{ $t('el.correctMarked', { count: result.rightQuestionAnswersCount }) }}
                    </v-chip>

                    <v-chip class="mr-2" v-if="!xs">
                      {{ $t('el.falseMarked', { count: result.falseQuestionAnswersCount }) }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text class="d-flex justify-space-around"></v-card-text>
          <v-card-actions class="justify-end">
            <v-btn class="mr-6" @click="backToOverview" :color="theme.elements.activeColor" dark rounded> zurück zur Übersicht </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import commonMixin from '@/mixins/common';
import dataUtils from '@/common/dataUtils';
import constants from './constants';
import elearningMixin from './ElearningMixin';

export default {
  name: 'ELQuestion',

  mixins: [commonMixin, elearningMixin],
  props: {
    // module: Object,
    // questions: Array,
  },
  mounted() {
    if (this.dataLoaded) {
      this.complete();
    }
  },

  computed: {
    ...mapState('elearning', [
      'dataLoaded',
      'modulesById',
      'userAnswersByQuestionId',
      'questionAnswers',
      'answers',
      'answersByQuestionId',
      'userStateByModuleId',
    ]),
    module() {
      console.debug('this.$route.params.moduleId', this.$route.params.moduleId);
      console.debug(' this.modulesById', this.modulesById);
      return this.modulesById[this.$route.params.moduleId];
    },
    questions() {
      return this.$store.state.elearning.questions.filter((q) => q.module_id === this.module.id);
    },
    moduleStats() {
      return this.$store.getters['elearning/getModuleStatistics'](this.module);
    },
    percentageCorrect() {
      return this.moduleStats.questionsCount === 0 ? 0 : Math.round((100 * this.moduleStats.correctOnes) / this.moduleStats.questionsCount);
    },
    result() {
      let fullRightQuestionsCount = 0,
        rightQuestionAnswersCount = 0,
        falseQuestionAnswersCount = 0,
        //deprecated way of counting
        rightCheckedCount = 0,
        rightLeftEmptyCount = 0,
        wrongCheckedCount = 0,
        missedChecksCount = 0; //number of checkboxes left empty although it should be checked

      //let questionAnswersByQuestionId = dataUtils.buildCombinedOneToManyMap(this.questionAnswers, (answer) => answer.question_id);
      let questionAnswersByQuestionId = this.answersByQuestionId;
      this.questions.forEach((question) => {
        let questionAnswers = questionAnswersByQuestionId[question.id]; // Array
        let userQuestionAnswers = this.userAnswersByQuestionId[question.id] || {};

        let correctUserquestionAnswers = 0;

        if (questionAnswers && userQuestionAnswers) {
          questionAnswers.forEach((answer) => {
            let userAnswer = userQuestionAnswers[answer.id];
            if (!userAnswer) {
              if (answer.is_correct == 1) {
                falseQuestionAnswersCount++;
                //deprecated but still suppported
                missedChecksCount++;
              } else {
                correctUserquestionAnswers++;
                rightQuestionAnswersCount++;
                //deprecated but still suppported
                rightLeftEmptyCount++;
              }
            } else if (userAnswer === true) {
              if (answer.is_correct == 1) {
                rightQuestionAnswersCount++;
                correctUserquestionAnswers++;
                //deprecated but still suppported
                rightCheckedCount++;
              } else {
                falseQuestionAnswersCount++;
                //deprecated but still suppported
                wrongCheckedCount++;
              }
            } else if (userAnswer === false) {
              if (answer.is_correct == 1) {
                falseQuestionAnswersCount++;
                //deprecated but still suppported
                missedChecksCount++;
              } else {
                rightQuestionAnswersCount++;
                correctUserquestionAnswers++;
                //deprecated but still suppported
                rightLeftEmptyCount++;
              }
            }
          });
          if (correctUserquestionAnswers === questionAnswers.length) fullRightQuestionsCount++;
        }
      });
      return {
        fullRightQuestionsCount,
        rightQuestionAnswersCount,
        falseQuestionAnswersCount,
        //deprecated way of counting
        rightCheckedCount,
        rightLeftEmptyCount,
        wrongCheckedCount,
        missedChecksCount,
      };
    },
  },
  methods: {
    complete() {
      let module = this.module;
      if (!module) {
        console.error('module is undefined');
        return;
      }
      console.debug('mark as complete');
      let userState = this.elmx_getModuleUserState(module);
      if (userState) {
        userState.status = constants.STATUS.finished;
      }
      userState.status = constants.STATUS.finished;

      let answersById = dataUtils.buildIdMap(this.answers, 'id');
      let moduleUserAnswers = [];
      this.questions.forEach((question) => {
        if (!question.id) console.debug('question.id undefined', JSON.stringify(question, null, 2));
        let userQuestionAnswers = this.userAnswersByQuestionId[question.id] || {}; // Object of answerId's and user entry (true or false)
        let clonedUserQuestionAnswers = JSON.parse(JSON.stringify(userQuestionAnswers));

        delete clonedUserQuestionAnswers._freezed;

        let questionUserAnswers = Object.keys(clonedUserQuestionAnswers).map((answerId) => {
          let answer = answersById[answerId];
          let isCorrect = this.$store.getters['elearning/isCorrectAnswer'](userQuestionAnswers, answer);
          return {
            questionId: answer.question_id,
            answerId,
            givenAnswer: userQuestionAnswers[answerId],
            evaluation: isCorrect,
          };
        });

        /**
        let hasFalseEvaluation = questionUserAnswers.some((answer) => answer.evaluation === false);
        // if there are false answers, filter through them and only save the false answers
        if (hasFalseEvaluation) {
          questionUserAnswers = questionUserAnswers.filter((answer) => answer.evaluation === false);
        }
        */

        moduleUserAnswers = moduleUserAnswers.concat(questionUserAnswers);
      });

      this.elmx_createAndSendSendboxItem({
        module: this.module,
        payload: { moduleUserAnswers },
        userState,
        text: this.$t('el.finished'),
        action: 'saveExamResult',
        showAsUserInfo: true,
        showInSendbox: true,
        writeAuditLog: true,
      });
    },
    backToOverview() {
      console.debug('backToOverview');
      let userState = this.elmx_getModuleUserState(this.module);
      if (userState) {
        userState.status = constants.STATUS.finished;
      }

      this.elmx_backToHome();
    },
  },
  watch: {
    dataLoaded(newValue, oldValue) {
      if (newValue) this.complete();
    },
  },
};
</script>

<style scoped>
.bottom-right {
  position: fixed !important;
  z-index: 1000000 !important;
  width: 100% !important;
  right: 20px !important;
  bottom: 10px !important;
}

.description {
  height: 120px;
  padding-top: 20px;
  align-items: start;
}
</style>
